import { sharedTheme } from './themes/shared';
import { talledosDarkTheme } from './themes/talledos-dark-theme';
import { talledosLightTheme } from './themes/talledos-light-theme';

export default {
  config: {
    initialColorModeName: 'default',
    useColorSchemeMediaQuery: true,
    useCustomProperties: false,
  },
  colors: {
    ...talledosDarkTheme.colors,
    modes: {
      light: talledosLightTheme.colors,
    },
  },
  links: {
    bold: { fontWeight: 'bold', color: 'primary', cursor: 'pointer' },
  },
  text: {
    code: {
      fontFamily: 'Menlo, monospace',
      fontSize: '0.9em',
      color: 'codeText',
    },
  },
  badges: {
    outline: {
      color: 'text',
      padding: '4px',
      fontWeight: 100,
      bg: 'transparent',
      boxShadow: 'inset 0 0 0 1px',
    },
  },
  buttons: {
    icon: {
      backgroundColor: 'transparent',
      color: 'primary',
      padding: 2,
      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: 'iconHover',
      },
    },
  },
  cards: {
    primary: {
      backgroundColor: 'background',
      borderRadius: '16px',
      overflow: 'hidden',
    },
  },
  styles: {
    hr: {
      borderTop: '1px solid',
      borderColor: 'borderSubtle',
    },
    root: {
      fontFamily:
        'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
      backgroundColor: 'background',
      color: 'text',
    },
  },
  ...sharedTheme,
};
